export default "__VITE_ASSET__467cce68__"